import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  snackBarSuccess: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
  },
  snackBarError: {
    backgroundColor: `${theme.palette.error.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
  },
}));

export default useStyles;
